import CrudTab from 'react/containers/pages/CrudTab';

class HoursOfServiceTypeDays extends CrudTab {

  componentDidMount() {
    try {
      const { parentId } = this.props.tab.extra;
      const router = App.Objects.HoursOfServiceTypeDays = new App.Routers.HoursOfServiceTypeDays();
      router.setParentId(parentId);
      router.list();
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate(prevProps) {
    const { active, tab: { pathname } } = this.props;
    const [hosTypeId, liveKey, mode, id] = pathname.split('/').slice(2);
    const router = App.Objects[liveKey];
    const isCommingFromAnotherTab = active !== prevProps.active;
    const didChangeTab = pathname !== prevProps.tab.pathname;

    if (!isCommingFromAnotherTab && active && didChangeTab) {
      switch (mode) {
        case 'edit':
          router.edit(hosTypeId, id);
          break;
        case 'new':
          router.form_new();
          break;
        default:
          router.list();
          break;
      }
    }
  }
}

export default HoursOfServiceTypeDays;
